import axios from 'axios';

const api = {
  async createNewSyntheticUser(newSyntheticUser) {
    const response = await axios.post(
      `/synthetic_user_conversation`,
      newSyntheticUser
    );
    return response.data;
  },
};

export default api;
